import React from 'react';

import Button from 'antd/es/button';
import Popconfirm from 'antd/es/popconfirm';

import colors from 'config/colors';
import Icon from 'components/Icon';

import { DownloadOutlined } from '@ant-design/icons';


export const EditAction = ({ handleAction }) => (
  <Button
    type="link"
    size="middle"
    icon={<Icon name="edit-2" size={16} color={colors.primary} />}
    onClick={handleAction(EditAction.actionType)} />
);

EditAction.actionType = 'edit';


export const DeleteAction = ({ handleAction, resource }) => (
  <Popconfirm
    key="delete"
    trigger="click"
    placement="bottomRight"
    title={`Are sure you want to delete this ${resource}?`}
    okText="Delete"
    okButtonProps={{ type: 'danger' }}
    cancelText="Cancel"
    icon={<Icon name={'alert-circle'} size={16} color={colors.error} />}
    onConfirm={handleAction(DeleteAction.actionType)}
  >
    <Button
      type="link"
      size="middle"
      icon={<Icon name="trash-2" size={16} color={colors.error} />}
    />
  </Popconfirm>
);

DeleteAction.actionType = 'delete';

export const DownloadAction = ({ handleAction, item, isDisabled = false }) => (
  <Button
    type="link"
    size="middle"
    icon={<DownloadOutlined />}
    onClick={handleAction(DownloadAction.actionType)}
    disabled={item.tag_img ? false : true} />
);

DownloadAction.actionType = 'download';
